<div class="content-data" *ngIf="contentList.length > 0">
    <mat-grid-list cols="3" class="content-type" *ngIf="!showGridList">
        <div [ngClass]="{'max-height-custom' : contentList.length == 9}">
        <div class="justify-content-center">
        <p class="contact-title">{{ contentType }}</p>
        <div class="contact-by-type" [ngClass]="{'no-wrap' : contentList.length == 5}">
            <mat-grid-tile-header *ngFor="let content of contentList.slice(0, itemsToShow)" class="social-media">
                <div>
                    <div class="show-buttons">
                    <button mat-icon-button *ngIf="content.editable" class="icon-dots content-icon" [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                        <mat-icon class="mat-icon-style">more_vert</mat-icon>
                    </button>
                      <mat-menu class="edit-delete-buttons-mat" #menu="matMenu">
                        <div class="edit-delete-buttons-mat">
                          <a (click)="openEditContent(content.id)">Edit</a>
                          <a *ngIf="!clicked" mat-raised-button color="warn"
                             (click)="deleteContent(content)">Delete</a>
                        </div>
                      </mat-menu>
                    </div>
                    <div class="image-preview-container">
                        <div class="image-preview size-fixed">
                            <img [src]="getContentImage(content.contentIcon)" class="img-fluid" alt="Image"/>
                        </div>
                    </div>
                  <div class="title-div mt-2">
                    <h3 class="payment_title"><p>{{ content.name }}</p></h3>
                  </div>
                </div>
            </mat-grid-tile-header>
        </div>
          <div class="load-more-container">
            <div *ngIf="contentList.length > 12" class="load-more" (click)="toggleShowMore()">
              {{ showMore ? 'See Less' : 'Load more' }}
            </div>
          </div>
        </div>
        </div>
    </mat-grid-list>
</div>
